export const JwtApiRoute = {
  Refresh: '/cockpit-api/token/refresh',
};
